<template>
  <div class="c-tab-ym">
    <div class="c-header-wrap">
      <div class="c-month-area">
        <div v-show="nodate" class="c-noym strong">{{ $T('common.no-date') }}</div>
        <div v-show="!nodate" ref="yearSwiper" class="c-year swiper-container" :style="styleY">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Slides -->
            <div v-for="y in initYears" :key="y.k" :id="`y-${y.k}`" class="swiper-slide c-yy">{{ y.k }}</div>
          </div>
        </div>
        <div class="c-sep strong" :style="styleS">{{ mLayout.separator }}</div>
        <div ref="monthSwiper" class="swiper-container" :style="styleM">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Slides -->
            <div v-for="m in initMonths" :key="m.k" :id="`ym-${m.k}`" class="swiper-slide c-ym">
              {{ toMonthStr(toMonth(m.k)) }}
            </div>
          </div>
        </div>

        <div class="c-swiper-cover l" :style="styleCL"></div>
        <div class="c-swiper-cover r" :style="styleCR"></div>

        <div class="c-btn-add">
          <v-tooltip bottom>
            <v-btn :disabled="isGuest" slot="activator" flat icon color="clr-btn" @click="onAddClicked">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <span>{{ createNewTitle }}</span>
          </v-tooltip>
        </div>

        <div class="c-btns">
          <div class="c-btn-prev le-tbs-hide">
            <v-tooltip bottom>
              <v-btn slot="activator" flat icon color="clr-black" @click="moveToPrev" :disabled="nodate">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <span>{{ $T('common.prev.month') }}</span>
            </v-tooltip>
          </div>

          <div class="c-btn-next le-tbs-hide">
            <v-tooltip bottom>
              <v-btn slot="activator" flat icon color="clr-black" @click="moveToNext" :disabled="nodate">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <span>{{ $T('common.next.month') }}</span>
            </v-tooltip>
          </div>

          <div class="c-btn-nodate" v-if="useNodate">
            <v-tooltip bottom>
              <v-btn slot="activator" flat icon color="clr-black" @click="current = 0" :disabled="current == 0">
                <v-icon>mdi-calendar-question</v-icon>
              </v-btn>
              <span>{{ $T('common.no-date') }}</span>
            </v-tooltip>
          </div>

          <div class="c-btn-today">
            <v-tooltip bottom>
              <v-btn slot="activator" flat icon color="clr-black" @click="current = now" :disabled="now == current">
                <v-icon>mdi-calendar-today</v-icon>
              </v-btn>
              <span>{{ $T('common.today') }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="c-content">
      <div ref="contentSwiper" class="swiper-container">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper"></div>
      </div>
    </div>

    <div class="c-slots">
      <div v-for="(s, idx) in slots" :id="`ym-slot-${s.idx}-${s.ym}`" class="swiper-slide">
        <slot :name="s.idx"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { CONST } from '../../constant';

export default {
  props: {
    cid: { type: Number, required: true },
    yyyymm: { type: Number, required: true },
    slots: { type: Array, required: true },
    createNewTitle: { type: String, required: true },
    useNodate: { type: Boolean, required: false, default: false },
  },
  watch: {
    cid(newValue, oldValue) {
      console.log(`cid changed from ${oldValue} to ${newValue}`);
      this.refreshData();
    },
    current(n, o) {
      if (!this.initialized) return;
      this.moveToYm(n, o);
    },
    w(n, o) {
      this.$nextTick(function() {
        this.adjustWidthParams();
      });
    },
    viewYyyy(n, o) {
      this.moveYearTo(n);
    },
    tabYmAdjust(n, o) {
      this.adjustHeightBySlotId(this.getCurrentSlotId(), 1000);
    },
  },
  beforeMount() {
    var ym = this.calcInitYm();
    this.now = Number(this.$moment().format('YYYYMM'));

    this.initYm = ym == 0 ? this.now : ym;
    this.current = ym;
    this.viewYyyy = this.toYear(ym);

    var ms = [this.toRecord(this.initYm)];
    var pym = this.initYm,
      nym = this.initYm;
    for (var i = 0, n = CONST.tab_ym.prepare.m; i < n; i++) {
      pym = this.toYyyyMm(--pym);
      ms.unshift(this.toRecord(pym));
      nym = this.toYyyyMm(++nym);
      ms.push(this.toRecord(nym));
    }
    this.initMonths = ms;

    var iy = this.toYear(this.initYm);
    var ys = [this.toRecord(iy)];
    var py = iy,
      ny = iy;
    for (var i = 0, n = CONST.tab_ym.prepare.y; i < n; i++) {
      ys.unshift(this.toRecord(++py));
      ys.push(this.toRecord(--ny));
    }
    this.initYears = ys;
  },
  data() {
    return {
      initYm: 0,
      current: 0,
      now: 0,
      viewYyyy: 0,
      preparingYm: null,
      initYears: null,
      yearSwiper: null,
      yearPreparing: true,
      initMonths: null,
      monthSwiper: null,
      monthSlidesPerView: 6,
      monthPreparing: true,
      contentSwiper: null,
      keyLeft: false,
      keyRight: false,
      keyFirstTarget: 0,
      reqIdx: 0,
      stopPrepareOnce: false,
      skipHistoryOnce: false,
      monthAppendedTime: 0,
      contentTouch: null,
      touchMoving: null,
      stageWidth: 0,
      initialized: false,
      touch: {
        midx: -1,
        mts: 0,
        yidx: -1,
        yts: 0,
      },
      mLayout: {
        sCount: 6,
        mOneWidth: 50,
        mMarginL: 120,
        yMarginL: 0,
        sMarginL: 0,
        separator: '/',
      },
      contentMoveRate: 0,
      tabArea: null,
    };
  },
  mounted() {
    var self = this;
    var ym = this.current;
    console.log('TabYearMonth monunted.');
    this.adjustWidthParams();

    this.$nextTick(function() {
      var initYIdx = 0;
      var y = this.toYear(this.initYm);
      for (var i = 0, n = this.initYears.length; i < n; i++) {
        if (this.initYears[i].k == y) {
          initYIdx = i;
        }
      }
      this.yearSwiper = new Swiper(this.$refs.yearSwiper, {
        // Optional parameters
        slidesPerView: 1,
        freeMode: true,
        initialSlide: initYIdx,
        speed: 300,
        direction: 'vertical',
        on: {
          init: self.onYearInit,
          slideChange: self.onYearSlideChange,
          transitionStart: self.onYearTransitionStart,
          transitionEnd: self.onYearTransitionEnd,
          touchStart: self.onYearTouchStart,
          touchEnd: self.onYearTouchEnd,
        },
      });

      this.monthSwiper = new Swiper(this.$refs.monthSwiper, {
        // Optional parameters
        slidesPerView: this.mLayout.sCount,
        freeMode: true,
        initialSlide: CONST.tab_ym.prepare.m,
        speed: 0,

        on: {
          init: self.onMonthInit,
          slideChange: self.onMonthSlideChange,
          transitionStart: self.onMonthTransitionStart,
          transitionEnd: self.onMonthTransitionEnd,
          touchStart: self.onMonthTouchStart,
          touchEnd: self.onMonthTouchEnd,
        },
      });
      this.setMonthAimation(false);
    });

    this.contentSwiper = new Swiper(this.$refs.contentSwiper, {
      // Optional parameters
      autoHeight: true,
      slidesPerView: 1,
      centeredSlides: true,

      on: {
        slidePrevTransitionStart: self.onContentSlidePrevTransitionStart,
        slideNextTransitionStart: self.onContentSlideNextTransitionStart,
        transitionStart: self.onContentTransitionStart,
        transitionEnd: self.onContentTransitionEnd,
        slideChangeTransitionEnd: self.onContentSlideChangeTransitionEnd,
        sliderMove: self.onContentSliderMove,
        touchStart: self.onContentTouchStart,
        touchEnd: self.onContentTouchEnd,
      },
    });

    this.$store.commit('CURRENT_YM', ym);

    var idx = this.prepareRequest(ym);
    this.preparingYm = ym;
    this.$nextTick(() => {
      var ele = this.getSlot(idx, ym);
      this.contentSwiper.appendSlide([ele]);
      this.contentSwiper.update();
      this.initialized = true;
      setTimeout(function() {
        if (self.current == ym) {
          self.adjustHeight(idx, ym);
          self.prepareSubContents(ym);
        }
      }, 1000);
    });

    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('keyup', this.onKeyup);
  },
  beforeDestroy() {
    console.log('destroy');
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('keyup', this.onKeyup);
    if (this.monthSwiper) this.monthSwiper.destroy();
    if (this.contentSwiper) this.contentSwiper.destroy();
  },
  computed: {
    styleCL() {
      var l = this.mLayout;
      return `width:${l.mMarginL}px;`;
    },
    styleCR() {
      var l = this.mLayout;
      return `left:${l.mMarginL + l.mOneWidth}px; width:${l.mOneWidth * (l.sCount - 1)}px;`;
    },
    styleM() {
      var l = this.mLayout;
      return `left:${l.mMarginL}px; width:${l.mOneWidth * l.sCount}px;${
        this.nodate ? 'visibility:hidden;' : 'visibility:visible;'
      }${
        this.contentMoveRate
          ? `transform:translateX(${this.contentMoveRate * l.mOneWidth}px)`
          : `transition:transform 300ms;transform:translateX(0)`
      }`;
    },
    styleY() {
      return `left:${this.mLayout.yMarginL}px;visibility:visible;`;
    },
    styleS() {
      return `left:${this.mLayout.sMarginL}px;${this.nodate ? 'visibility:hidden;' : 'visibility:visible;'}`;
    },
    nodate() {
      return this.current < CONST.tab_ym.limit.min;
    },
    tabYmAdjust() {
      return this.$store.state.tools.tabYmAdjustHeight;
    },
  },
  methods: {
    isValidYm(ym) {
      return (
        ym == 0 ||
        (ym >= CONST.tab_ym.limit.min &&
          ym <= CONST.tab_ym.limit.max &&
          Math.floor(ym % 100) >= 1 &&
          Math.floor(ym % 100) <= 12)
      );
    },
    setMonthAimation(onoff) {
      if (onoff) {
        var self = this;
        setTimeout(function() {
          self.monthSwiper.animating = true;
          self.monthSwiper.params.speed = 300;
        }, 300);
      } else {
        this.monthSwiper.animating = false;
        this.monthSwiper.params.speed = 0;
      }
    },
    stopAnimation() {
      this.monthSwiper.animating = false;
      this.monthSwiper.params.speed = 0;
    },
    moveToYm(to, from) {
      if (!to && to != 0) return console.error(`invalid yyyymm=${to}`);

      console.log('new current ' + to);
      this.$store.commit('CURRENT_YM', to);
      this.prepareContent(to, to == 0 || (from != 0 && to > from));
      this.moveMonthToYm(to);
      if (to != 0) this.viewYyyy = this.toYear(to);
    },
    adjustWidthParams() {
      var rect = document.getElementsByClassName('c-tab-ym')[0].getBoundingClientRect();
      var w = rect.width;
      this.stageWidth = w;

      var p = CONST.tab_ym.layout[this.userLang];
      if (!p) {
        console.warn(`there is no lang layout ${this.userLang}. use default`);
        p = CONST.tab_ym.layout.default;
      }

      var l = {};
      l.sCount = Math.floor((w - p.m_left) / p.width);
      l.mOneWidth = p.width;
      l.mMarginL = p.m_left;
      l.yMarginL = p.y_left;
      l.sMarginL = p.sep_left;
      l.separator = p.separator;
      this.mLayout = l;

      if (!this.monthSwiper) return;
      var idx = this.monthSwiper.activeIndex;
      this.monthSwiper.slidesPerView = l.sCount;
      this.monthSwiper.slideTo(idx);
    },
    calcInitYm() {
      // yyyymm === 0 is the "no-date" marker (isValidYm allows it) and must be honored when the consumer
      // supports it (album: useNodate). The old `this.yyyymm &&` guard short-circuited on 0 and fell through
      // to the current month — the bug where /album/:id/n opened the current month instead of 日付なし.
      var initYm = Number(this.yyyymm);
      if (this.isValidYm(initYm) && (initYm !== 0 || this.useNodate)) {
        return initYm;
      }
      var cache = this.loadYm(null);
      if (cache) {
        if (cache == 'n') return 0;
        if (this.isValidYm(Number(cache))) return Number(cache);
      }
      return Number(this.$moment().format('YYYYMM'));
    },
    historyBack(ym) {
      // called from parent component
      if (this.current == ym) return;
      this.skipHistoryOnce = true;
      this.current == ym;
    },
    refreshData() {
      // called when community changed
      console.log(`refresh data ym`);
      var swiper = this.contentSwiper;
      var ym = this.current;
      swiper.removeAllSlides();
      swiper.update();
      var idx = this.prepareRequest(ym);
      this.preparingYm = ym;
      this.$nextTick(function() {
        var ele = this.getSlot(idx, ym);
        swiper.appendSlide([ele]);
        swiper.update();
        this.adjustHeight(idx, ym);
        this.moveToYm(ym, ym);
        var self = this;
        setTimeout(function() {
          self.prepareSubContents(ym);
        }, 300);
      });
    },
    adjustHeight(idx, ym) {
      var slotId = `ym-slot-${idx}-${ym}`;
      this.adjustHeightBySlotId(slotId, 3000);
    },
    adjustHeightBySlotId(slotId, msec) {
      var ele = document.getElementById(slotId);
      if (!ele) return console.warn(`${slotId} not found`);
      var tgt = ele.closest('.swiper-wrapper');
      if (!tgt) return console.warn(`${slotId} swiper-wrapper not found`);

      var c = this.current;

      var height = ele.offsetHeight + 'px';
      tgt.style.height = height;

      var self = this;
      var count = 0;
      var maxCount = msec / 50;
      var id = setInterval(function() {
        if (count > maxCount || c != self.current) {
          console.log(`clear height check`);
          clearInterval(id);
        }
        count++;
        var height = ele.offsetHeight + 'px';
        if (tgt.style.height != height && height != '0px') {
          console.log(`height reset to ${height} ${count * 50}ms`);
          tgt.style.height = height;
        }
      }, 50);
    },
    adjustHeightRestart(msec) {
      this.adjustHeightBySlotId(this.getCurrentSlotId(), msec);
    },
    getCurrentSlotId() {
      return this.contentSwiper.slides[this.contentSwiper.activeIndex].id;
    },
    prepareRequest(ym) {
      var idx = this.reqIdx;
      this.reqIdx++;
      this.$emit('prepareSlot', Number(ym), idx);
      return idx;
    },
    prepareSubSlotRequest(ym, current) {
      var idx = this.reqIdx;
      this.reqIdx++;
      this.$emit('prepareSubSlot', ym, idx, current);
      return idx;
    },
    prepareContent(ym, toNext, force) {
      if ((this.keyLeft || this.keyRight) && !force) {
        console.log('stop prepare for key down ' + ym);
        return;
      }

      if (this.skipHistoryOnce) {
        this.skipHistoryOnce = false;
      } else {
        this.$emit('saveHistory', ym);
      }

      if (this.stopPrepareOnce) {
        this.stopPrepareOnce = false;
        console.log('stop prepare once ' + ym);
        return;
      }

      var toYm = this.getSlideYm(toNext ? 1 : -1);
      var saveSlideDiff = 0;
      if (toYm == ym) {
        saveSlideDiff = toNext ? 1 : -1;
      }

      this.clearInactives(this.contentSwiper, saveSlideDiff);
      this.preparingYm = ym;
      var idx = -1;
      if (saveSlideDiff == 0) {
        console.log(`prepare ${ym} next=${toNext}`);
        idx = this.prepareRequest(ym);
      }
      this.$nextTick(function() {
        if (saveSlideDiff == 0) {
          if (!this.checkPreparing(ym)) return;
          var ele = this.getSlot(idx, ym);
          this.append(this.contentSwiper, ele, toNext);
        }

        if (toNext) {
          this.contentSwiper.slideNext();
        } else {
          this.contentSwiper.slidePrev();
        }
      });
    },
    getSlot(idx, ym) {
      return document.getElementById(`ym-slot-${idx}-${ym}`);
    },
    getYmSlideIdx(ym) {
      for (var i = this.contentSwiper.slides.length - 1; i >= 0; i--) {
        if (ym == Number(this.contentSwiper.slides[i].id.split('-')[3])) {
          return i;
        }
      }
      return -1;
    },
    inview(diffFromActiveIndex) {
      var idx = this.getSlideRequestIdx(diffFromActiveIndex);
      if (idx == -1) return false;
      console.log(`inview ${idx}`);
      this.$emit('inview', idx);
      return true;
    },
    inviewByYm(ym) {
      var idx = this.getYmSlideIdx(ym);
      if (idx == -1) return;
      console.log(`inview ${idx}`);
      this.$emit('inview', Number(this.contentSwiper.slides[idx].id.split('-')[2]));
    },
    getSlideRequestIdx(diffFromCurrentIndex) {
      var idx = this.getYmSlideIdx(this.current);
      if (idx == -1) return -1;
      var tgtIdx = idx + diffFromCurrentIndex;
      if (tgtIdx < 0 || tgtIdx > this.contentSwiper.slides.length - 1) {
        // no problem just bad timing.
        console.log(`there is no index ${tgtIdx} in current content swiper.`);
        return -1;
      }
      return Number(this.contentSwiper.slides[tgtIdx].id.split('-')[2]);
    },
    getSlide(diffFromActiveIndex) {
      var index = this.contentSwiper.activeIndex + diffFromActiveIndex;

      if (index < 0 || !this.contentSwiper.slides || index > this.contentSwiper.slides.length - 1) {
        // no problem just bad timing.
        console.log(`there is no index ${index} in current content swiper.`);
        return null;
      }
      return this.contentSwiper.slides[index];
    },
    getSlideYm(diffFromActiveIndex) {
      var slide = this.getSlide(diffFromActiveIndex);
      if (!slide) return -1;
      return Number(slide.id.split('-')[3]);
    },
    prepareSubContents(ym) {
      if (!this.checkPreparing(ym)) return;

      var swiper = this.contentSwiper;

      if (ym == 0) return this.clearInactives(swiper, 0);

      var saveSlideDiff = 0;
      var prevYm = this.toYyyyMm(ym - 1);
      var nextYm = this.toYyyyMm(ym + 1);
      if (this.getSlideYm(-1) == prevYm) {
        saveSlideDiff = -1;
      } else if (this.getSlideYm(1) == nextYm) {
        saveSlideDiff = 1;
      }

      // clear first
      this.clearInactives(swiper, saveSlideDiff);

      console.log(`prepare sub ${prevYm} ${nextYm} save=${saveSlideDiff}`);
      var prevIdx = saveSlideDiff == -1 ? -1 : this.prepareSubSlotRequest(prevYm, ym);
      var nextIdx = saveSlideDiff == 1 ? 1 : this.prepareSubSlotRequest(nextYm, ym);

      this.$nextTick(function() {
        if (!this.checkPreparing(ym)) return;
        if (prevIdx != -1) {
          var prev = this.getSlot(prevIdx, prevYm);
          if (prev) {
            this.append(swiper, prev, false);
            swiper.update();
          } else {
            console.log(`failed to get slot with idx=${prevIdx}, ym=${prevYm}`);
          }
        }
        if (nextIdx != -1) {
          var next = this.getSlot(nextIdx, nextYm);
          if (next) {
            this.append(swiper, next, true);
            swiper.update();
          } else {
            console.log(`failed to get slot with idx=${nextIdx}, ym=${nextYm}`);
          }
        }
      });
    },
    clearInactives(swiper, saveSlideDiff) {
      if (!swiper.slides) return;

      var idx = swiper.activeIndex;
      var subIdx = idx + (!saveSlideDiff ? 0 : saveSlideDiff);
      var rmIdxs = [];
      var rms = [];
      for (var i = 0, n = swiper.slides.length; i < n; i++) {
        if (i == idx || i == subIdx) continue;
        rms.push(i);
        rmIdxs.push(Number(this.contentSwiper.slides[i].id.split('-')[2]));
      }
      if (rms.length == 0) return;
      swiper.removeSlide(rms);
      swiper.update();
      var self = this;
      setTimeout(function() {
        self.$emit('removeSlots', rmIdxs);
      }, 500);
    },
    append(swiper, element, isNext) {
      swiper.slides.length;
      var idx = swiper.activeIndex;

      if (!element) return console.warn(`appended element is invalid. isNext=${isNext}`);

      if (isNext) {
        if (idx == swiper.slides.length - 1) {
          swiper.appendSlide([element]);
          console.log(`append last element.id=${element.id} next=${isNext}`);
        } else {
          swiper.addSlide(idx + 1, [element]);
          console.log(`add ${idx + 1} element.id=${element.id} next=${isNext}`);
        }
      } else {
        if (idx == 0) {
          swiper.prependSlide([element]);
          console.log(`prepend element.id=${element.id} next=${isNext}`);
        } else {
          swiper.addSlide(idx - 1, [element]);
          console.log(`add ${idx} element.id=${element.id} next=${isNext}`);
        }
      }
      swiper.update();
    },
    checkPreparing(ym) {
      if (this.preparingYm == ym) return true;
      console.warn(`other ym preparing. ${ym} ${this.preparingYm}`);
      return false;
    },
    toYear(ym) {
      return Math.floor(ym / 100);
    },
    toMonth(ym) {
      return Math.floor(ym % 100);
    },
    toViewYm(ym) {
      return this.toYear(ym) + ' / ' + this.toMonth(ym);
    },
    moveYearTo(y) {
      var ys = this.yearSwiper;
      if (!ys) return;
      if (ys.slides.length == 0) {
        // first in nodate and first view of ym slide.
        this.yearPreparing = true;
        this.$nextTick(function() {
          ys.prependSlide(this.toYearRecordDiv(y));
          ys.update();
          ys.slideTo(0, 0);
          this.$nextTick(function() {
            this.resetYearButThis();
          });
        });
        return;
      }

      var s = Number(ys.slides[0].id.split('-')[1]);
      var e = Number(ys.slides[ys.slides.length - 1].id.split('-')[1]);
      if (e <= y && y <= s) {
        ys.slideTo(s - y);
        var self = this;
        setTimeout(function() {
          if (y == Number(ys.slides[ys.activeIndex].id.split('-')[1])) {
            self.resetYearButThis();
          }
        }, 300);
        return;
      }

      // whem no slide
      this.yearPreparing = true;
      ys.prependSlide(this.toYearRecordDiv(y));
      ys.update();
      ys.slideTo(0, 0);
      ys.update();

      this.$nextTick(function() {
        this.resetYearButThis();
      });
      return;
    },
    resetYearButThis() {
      var ys = this.yearSwiper;
      this.yearPreparing = true;

      var cidx = ys.activeIndex;
      var y = Number(ys.slides[cidx].id.split('-')[1]);

      var idxs = [];
      for (var i = cidx + 1, n = ys.slides.length; i < n; i++) {
        idxs.push(i);
      }
      ys.removeSlide(idxs);
      idxs = [];
      for (var i = 0, n = cidx; i < n; i++) {
        idxs.push(i);
      }
      ys.removeSlide(idxs);

      var ny = y,
        py = y;
      for (var i = 0, n = CONST.tab_ym.prepare.y; i < n; i++) {
        ys.prependSlide(this.toYearRecordDiv(++py));
        ys.appendSlide(this.toYearRecordDiv(--ny));
      }
      ys.update();
      this.$nextTick(function() {
        this.yearPreparing = false;
      });
    },
    moveMonthToYm(ym, fast) {
      var ms = this.monthSwiper;
      if (!ms || !ym) return;

      console.log(`move to ${ym}`);

      var idx = ms.activeIndex;
      if (this.getMonthYm(idx) == ym) return;
      if (!ms.isEnd && this.getMonthYm(idx + 1) == ym) return ms.slideNext(fast ? 0 : 300);
      if (!ms.isBeginning && this.getMonthYm(idx - 1) == ym) return ms.slidePrev(fast ? 0 : 300);

      if (this.getMonthYm(ms.slides.length - 1) < ym || ym < this.getMonthYm(0)) {
        // if out of range recreate.
        this.monthPreparing = true;
        ms.prependSlide(this.toMonthRecordDiv(ym));
        ms.update();
        ms.slideTo(0, 0);
        ms.update();
        this.$nextTick(function() {
          var idxs = [];
          for (var i = 1, n = ms.slides.length; i < n; i++) {
            idxs.push(i);
          }
          ms.removeSlide(idxs);
          this.addMonthPrev(CONST.tab_ym.prepare.m);
          this.addMonthNext(CONST.tab_ym.prepare.m);
          ms.update();
          this.findAndGo(ym, fast);
          this.$nextTick(function() {
            this.monthPreparing = false;
          });
        });
        return;
      }

      if (this.findAndGo(ym, fast)) return;
      console.error(`there is no slide for ${ym}`);
    },
    findAndGo(ym, fast) {
      for (var i = 0, n = this.monthSwiper.slides.length; i < n; i++) {
        if (this.getMonthYm(i) == ym) {
          console.log(`move to index ${i} for ym ${ym}`);
          this.monthSwiper.slideTo(i, fast ? 0 : 300);
          this.monthSwiper.update();
          // this.monthSwiper.activeIndex = i;
          return true;
        }
      }
      console.log(`there is no month slide for ym ${ym}`);
      return false;
    },
    calcAddCount(ym1, ym2) {
      return Math.ceil((Math.abs(ym1 - ym2) / 100) * 12) + 60;
    },
    moveToPrev() {
      if (this.nodate) return;
      this.current = this.toYyyyMm(this.current - 1);
    },
    moveToNext() {
      if (this.nodate) return;
      this.current = this.toYyyyMm(this.current + 1);
    },
    toYyyyMm(yyyymm) {
      if (yyyymm == 0) return 0;
      if (yyyymm < CONST.tab_ym.limit.min) return CONST.tab_ym.limit.min;
      if (yyyymm > CONST.tab_ym.limit.max) return CONST.tab_ym.limit.max;
      return this.$utils.toYyyyMm(yyyymm);
    },
    toRecord(v) {
      return { k: v };
    },
    toMonthStr(m) {
      return CONST.tab_ym.month_format[m];
    },
    getMonthId(idx) {
      return this.monthSwiper.slides[idx].id;
    },
    getMonthYm(idx) {
      return Number(this.getMonthId(idx).split('-')[1]);
    },
    getMonthY(idx) {
      return this.toYear(this.getMonthYm(idx));
    },
    toYearRecordDiv(y) {
      return `<div id="y-${y}" class="swiper-slide c-yy">${y}</div>`;
    },
    toMonthRecordDiv(ym) {
      return `<div id="ym-${ym}" class="swiper-slide c-ym">${this.toMonthStr(this.toMonth(ym))}</div>`;
    },
    addMonthPrev(count) {
      if (count <= 0) return;
      var ym = this.getMonthYm(0),
        slides = [];
      for (var i = 0; i < count; i++) {
        ym = this.toYyyyMm(--ym);
        slides.push(this.toMonthRecordDiv(ym));
      }
      console.log('prepend ' + count);
      this.monthSwiper.prependSlide(slides);
    },
    addMonthNext(count) {
      if (count <= 0) return;
      var ym = this.getMonthYm(this.monthSwiper.slides.length - 1),
        slides = [];
      for (var i = 0; i < count; i++) {
        ym = this.toYyyyMm(++ym);
        slides.push(this.toMonthRecordDiv(ym));
      }
      console.log('append ' + count);
      this.monthSwiper.appendSlide(slides);
    },
    removeMonthNext(leaveCount) {
      if (this.activeIndex >= this.monthSwiper.slides.length - leaveCount - 1) return;
      var idxs = [];
      for (var i = this.activeIndex + leaveCount + 1, n = this.monthSwiper.slides.length; i < n; i++) {}
      this.monthSwiper.removeSlide(idxs);
    },

    onYearInit() {
      this.yearPreparing = false;
    },
    onYearSlideChange() {
      if (!this.yearSwiper) return;
      this.touch.yidx = this.yearSwiper.activeIndex;
    },
    onYearTransitionStart() {
      console.log('onYearTransitionStart');
      this.onYearStartAction();
    },
    onYearTransitionEnd() {
      console.log('onYearTransitionEnd');
      this.onYearEndAction();
    },
    onYearTouchStart(e) {
      console.log('onYearTouchStart');
      this.onYearStartAction();
    },
    onYearTouchEnd(e) {
      console.log('onYearTouchEnd');
      this.onYearEndAction();
    },
    onYearStartAction() {
      if (!this.yearSwiper) return;
      this.touch.yts = time();
    },
    onYearEndAction() {
      if (this.yearPreparing || !this.yearSwiper) return;
      var ys = this.yearSwiper;
      var t = this.touch;
      t.te = time();
      var startTime = t.ts;
      var self = this;
      setTimeout(function() {
        // not restarted
        if (startTime == t.ts) {
          // ys.slideTo(self.touch.yidx);
          ys.slideToClosest(300);
          ys.update();
          var y = Number(ys.slides[ys.activeIndex].id.split('-')[1]);
          if (self.viewYyyy == y) return;
          self.viewYyyy = y;
          var m = self.toMonth(self.getMonthYm(self.monthSwiper.activeIndex));
          var ym = y * 100 + m;
          self.moveMonthToYm(ym, true);
          self.current = ym;
        }
      }, 10);
    },

    onMonthInit() {
      this.setMonthAimation(true);
      this.$nextTick(function() {
        this.monthSwiper.update();
        this.monthPreparing = false;
      });
    },
    onMonthSlideChange() {
      if (!this.monthSwiper) return;
      console.log('slide change!');
      this.viewYyyy = this.getMonthY(this.monthSwiper.activeIndex);
      this.touch.midx = this.monthSwiper.activeIndex;
      if (this.monthSwiper.isEnd || this.monthSwiper.isBeginning) {
        console.log('adjust slides!');
        this.adjustMonthCount();
      }
    },
    onMonthTransitionStart() {
      console.log('onMonthTransitionStart');
      this.onMonthStartAction();
    },
    onMonthTransitionEnd() {
      console.log('onMonthTransitionEnd');
      this.onMonthEndAction();
    },
    onMonthTouchStart(e) {
      console.log('onMonthTouchStart');
      this.onMonthStartAction();
    },
    onMonthTouchEnd(e) {
      console.log('onMonthTouchEnd');
      this.onMonthEndAction();
    },
    onMonthStartAction() {
      if (!this.monthSwiper) return;
      this.touch.mts = time();
    },
    onMonthEndAction() {
      if (!this.monthSwiper) return;
      var ms = this.monthSwiper;
      var t = this.touch;
      t.te = time();
      var startTime = t.ts;
      var self = this;
      setTimeout(function() {
        // not restarted
        if (startTime == t.ts) {
          // ms.slideTo(self.touch.midx);
          ms.slideToClosest(300);
          self.current = self.getMonthYm(ms.activeIndex);
        }
      }, 10);
    },
    adjustMonthCount() {
      if (this.monthPreparing || !this.monthSwiper) return;
      var idx = this.monthSwiper.activeIndex;
      var c = CONST.tab_ym.prepare.m;
      if (idx == c) return;

      this.setMonthAimation(false);
      this.monthPreparing = true;

      var ym = this.getMonthYm(idx);
      console.log(`adjust slides ${ym}`);

      this.$nextTick(function() {
        var sc = this.monthSwiper.slides.length;
        if (idx < c) {
          var idxs = [];
          for (var i = idx + c + 1, n = sc; i < n; i++) {
            idxs.push(i);
          }
          if (idxs.length > 0) this.monthSwiper.removeSlide(idxs);
          this.addMonthPrev(c - idx);
        } else {
          this.addMonthNext(idx + c - sc + 1);
          var idxs = [];
          for (var i = 0, n = idx - c; i < n; i++) {
            idxs.push(i);
          }
          if (idxs.length > 0) this.monthSwiper.removeSlide(idxs);
        }
        this.monthSwiper.update();
        this.findAndGo(ym, true);
        this.$nextTick(function() {
          this.findAndGo(ym, true);
          this.setMonthAimation(true);
          this.monthPreparing = false;
        });
      });
    },

    onContentSlidePrevTransitionStart() {
      this.doTransition(-1);
    },
    onContentSlideNextTransitionStart() {
      this.doTransition(1);
    },
    doTransition(diff) {
      if (!this.touchMoving) return;
      this.touchMoving.inviewRight = false;
      this.touchMoving.inviewLeft = false;
      this.touchMoving = null;
      var ym = this.toYyyyMm(this.current + diff);
      this.stopPrepareOnce = true;
      this.preparingYm = ym;
      this.current = ym;
    },
    onContentSlideChangeTransitionEnd() {
      console.log(`content transition end`);
      this.prepareSubContents(this.current);
    },
    onContentTransitionStart() {
      this.contentMoveRate = 0;
    },
    onContentTransitionEnd() {
      this.touchMoving = null;
    },
    onContentSliderMove(e) {
      var s = this.contentSwiper;
      // if (s.activeIndex != 1 || s.slides.length != 3) {
      //   this.touchMoving = null;
      //   return;
      // }
      var target;
      if (this.touchMoving) {
        target = this.touchMoving.t;
      } else {
        target = e.target.closest('.swiper-slide');
        if (target == null) {
          console.warn('could not found swiper-slide.');
          return;
        }
        this.touchMoving = { t: target };
      }
      var r = this.calcMoveRate(target);
      this.contentMoveRate = r;
      if (r < 0) {
        if (this.touchMoving.inviewRight != this.current) {
          this.inview(1);
          this.touchMoving.inviewRight = this.current;
        }
      } else if (r > 0) {
        if (this.touchMoving.inviewLeft != this.current) {
          this.inview(-1);
          this.touchMoving.inviewLeft = this.current;
        }
      }
    },
    onContentTouchStart(e) {
      var ct = pointerEventToXY(e);
      ct.t = time();
      this.contentTouch = ct;
    },
    onContentTouchEnd(e) {
      console.log('onContentTouchEnd - ' + !!this.touchMoving);
      var xy = pointerEventToXY(e);
      var ct = this.contentTouch;
      var mv = Math.max(Math.abs(ct.x - xy.x), Math.abs(ct.y - xy.y));
      var t = time() - t;
      this.$store.commit('SET_TABYM_TOUCHEND', { event: e, moving: this.touchMoving, px: mv, t: t });
      if (!this.touchMoving) return;
      var r = Math.abs(this.calcMoveRate(this.touchMoving.t));
    },

    calcMoveRate(t) {
      if (!this.tabArea) {
        this.tabArea = t.closest('.c-tab-ym');
      }
      return (t.getBoundingClientRect().left - this.tabArea.getBoundingClientRect().left) / t.clientWidth;
    },

    onKeydown(e) {
      if (this.isOpeningDialog) return;
      console.log('down');
      if (e.keyCode == 37) {
        this.keyLeft = true;
        this.moveToPrev();
        if (!this.keyFirstTarget) {
          this.keyFirstTarget = this.current;
          console.log(`move to ${this.current}`);
          this.prepareContent(this.current, false, true);
        }
      } else if (e.keyCode == 39) {
        this.keyRight = true;
        this.moveToNext();
        if (!this.keyFirstTarget) {
          this.keyFirstTarget = this.current;
          console.log(`move to ${this.current}`);
          this.prepareContent(this.current, true, true);
        }
      }
    },
    onKeyup(e) {
      if (this.isOpeningDialog) return;
      console.log('keyup');
      if (e.keyCode == 37) {
        this.keyLeft = false;
        this.current = this.getMonthSwiperCurrentYm();
        if (this.keyFirstTarget != this.current) {
          this.prepareContent(this.current, false);
        }
        this.keyFirstTarget = 0;
      } else if (e.keyCode == 39) {
        this.keyRight = false;
        this.current = this.getMonthSwiperCurrentYm();
        if (this.keyFirstTarget != this.current) {
          this.prepareContent(this.current, true);
        }
        this.keyFirstTarget = 0;
      }
    },
    getMonthSwiperCurrentYm() {
      var ym = Number(this.monthSwiper.slides[this.monthSwiper.activeIndex].id.split('-')[1]);
      console.log(ym);
      return ym;
    },
    onAddClicked() {
      this.$emit('add');
    },
  },
};
</script>

<style scoped>
.c-tab-ym {
  position: relative;
}
.c-header-wrap {
  position: sticky;
  top: 79px;
  z-index: 5;
}
.le-tbs .c-header-wrap {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
}
.c-header {
  position: relative;
  height: 45px;
  padding-top: 15px;
  background-color: white;
}
.le-tbs .c-header {
  height: 30px;
  padding-top: 8px;
}
.c-month-area {
  position: relative;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  background-color: white;
  overflow: hidden;
}
.le-tbs .c-month-area {
  height: 48px;
}
.c-swiper-cover {
  position: absolute;
  top: 0;
  height: 100%;
  background-color: #fff;
  z-index: 1;
  pointer-events: none;
}
.c-swiper-cover.r {
  box-shadow: -8px 0px 4px -4px #fff;
}
.c-swiper-cover.l {
  left: 0;
  box-shadow: 8px 0px 4px -4px #fff;
}
.c-noym {
  position: absolute;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  z-index: 5;
}
.le-tbs .c-noym {
  left: 20px;
}
.c-year {
  visibility: hidden;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  width: 50px;
  z-index: 5;
}
.le-tbs .c-year {
}
.c-sep {
  visibility: hidden;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  z-index: 5;
}
.c-btns {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 80px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-btns button {
  margin: 2px;
}
.le-tbs .c-btns {
  right: 65px;
}
.c-btn-today {
  z-index: 5;
}
.le-tbs .c-btn-today {
  top: 9px;
}
.c-btn-nodate {
  z-index: 5;
}
.le-tbs .c-btn-nodate {
  top: 9px;
}
.c-btn-prev {
  z-index: 5;
}
.c-btn-next {
  z-index: 5;
  margin-right: 2px;
}
.c-btn-prev i,
.c-btn-next i {
  font-size: 30px;
}

.c-btn-add {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  z-index: 5;
}
.le-tbs .c-btn-add {
  right: 12px;
  top: 2px;
  font-size: 12px;
  transform: initial;
}
.c-btn-add button {
  width: 36px !important;
  height: 36px !important;
}
.le-tbs .c-btn-add button {
  width: 32px !important;
  height: 32px !important;
}
.c-btn-add button i {
  font-size: 28px !important;
}
.c-slots {
  visibility: hidden;
  overflow: hidden;
  height: 0px;
}
</style>
